/**
 * Admin test session — the PWA opened from a desktop browser instead of a tablet.
 *
 * On a real tablet the identity comes from the client certificate installed on the
 * device, so nothing here runs. When an admin opens the link generated from the webapp
 * (`.../?t=<token>`), the token takes the certificate's place for the tab it was opened
 * in. The backend only honours it for tablets of a plant flagged `is_test`.
 */

const STORAGE_KEY = 'biofarma_pwa_test_token';
const QUERY_PARAM = 't';

/** Kept in sync with TEST_SESSION_HEADER in backend/src/api/middleware/tabletAuth.ts */
export const TEST_SESSION_HEADER = 'X-Pwa-Test-Token';

/**
 * Moves the token from the URL into sessionStorage and cleans the address bar, so it
 * is not left in the browser history or copied around by mistake. sessionStorage keeps
 * the session confined to the tab it was opened in.
 */
export function captureTestToken(): void {
  try {
    const url = new URL(window.location.href);
    const token = url.searchParams.get(QUERY_PARAM);
    if (!token) return;
    sessionStorage.setItem(STORAGE_KEY, token);
    url.searchParams.delete(QUERY_PARAM);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  } catch {
    // Private browsing modes can deny storage — the session simply won't start
  }
}

export function getTestToken(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearTestToken(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Full-screen notice when the 2h token runs out: every later call would fail anyway. */
export function showTestSessionExpired(): void {
  clearTestToken();
  if (document.getElementById('pwa-test-session-expired')) return;
  const overlay = document.createElement('div');
  overlay.id = 'pwa-test-session-expired';
  overlay.style.cssText =
    'position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;' +
    'background:#1c3f6e;color:#fff;font-family:system-ui,sans-serif;text-align:center;padding:24px';
  overlay.innerHTML =
    '<div><h1 style="font-size:28px;font-weight:700;margin-bottom:12px">Sessione di test scaduta</h1>' +
    '<p style="font-size:18px;opacity:.9">Genera un nuovo link dalla webapp, in Amministrazione &rsaquo; Tablet.</p></div>';
  document.body.appendChild(overlay);
}
